<template>
    <div class="download" v-if="arquivo" :style="'max-width:'+(fullWidth ? '100%' : this.window.width*0.5+' px')+' !important'">

        <el-popover
          placement="top"
          trigger="click"
        >

          <div class="col-md-12">
            <b>Arquivo:</b> ({{arquivo.id}}) {{arquivo.name}}
          </div>

          <div class="col-md-12">
            <b>Tamanho:</b> {{toMb(arquivo.size)}} 
            <span v-if="arquivo.width && arquivo.height">
              ({{arquivo.width}}x{{arquivo.height}})
            </span>
          </div>

          <div class="col-md-12 text-center pt-2 pb-2" v-if="arquivo.id  && arquivo.type && arquivo.type.indexOf('image') != -1">
            <el-image
              style="width:150px;height:150px"
              title="Clique para visualizar a imagem"
              :src="displayFile(arquivo)"
              fit="scale-down"
              :preview-src-list="[displayFile(arquivo)]"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline fa-2x"></i>
              </div>
            </el-image>
          </div>

          <div class="col-md-12 text-center" v-if="arquivo.id">
              <ed-button 
                type="primary" 
                @click="downloadFile(arquivo)" 
                size="small"
                value="Baixar Arquivo"
                icon="fa fa-download"
              />

              <ed-button 
                type="danger" 
                @click="deleteFile(arquivo)" 
                size="small"
                value="Deletar Arquivo"
                icon="fa fa-times"
                :loading="loadingDelete"
              />
          </div>

          <span slot="reference">
            <b>
              <a href="#">{{arquivo.name}} ({{toMb(arquivo.size)}})</a>
            </b>
          </span>
        </el-popover>

    </div>
</template>

<script>

    import Fct from 'common/fct';
    import Rest from 'common/rest';
    import EdButton from 'common/button';

    export default {
        name:"upload",
        components:{EdButton},
        mixins:[Rest,Fct],

        props:{
          arquivo:{
            type:[Object,String],
            default:function () { return null }
          },
          fullWidth:{
            type:[Boolean],
            default:function () { return false }
          }
        },

        data () {
          return {
            id: 0,
            loadingDelete:false
          }
        },

        mounted() {
          this.inicialize(); 
        },

        watch:{
          arquivo(){
            this.inicialize(); 
          },
        },

        methods:{

            inicialize: function(){
              this.id = (new Date()).getTime().toString();
            },

            downloadFile: function(arquivo){

              var id = ((arquivo && arquivo.id) ? arquivo.id : (this.arquivo && this.arquivo.id ? this.arquivo.id : null));

              if(!id)alert('Arquivo inválido');

              this.open('arquivo/'+this.toMd5(id)+'/download');
            },

            displayFile(arquivo){
              return this.getUrl('arquivo/'+this.toMd5(arquivo.id)+'/display');
            },

            deleteFile(arquivo){
              this.loadingDelete = true;
              this.post('arquivo/'+this.toMd5(arquivo.id)+'/deletar').then((result)=>{
                this.loadingDelete = false;
                result = result[0];
                if(result.status == 200){
                  this.edMsg('Arquivo removido com sucesso');
                  this.$emit('deleted', arquivo);
                }
                else{
                  this.edMsg('Erro ao remover arquivo','error');
                }
              });
            }
        }
    }
</script>


<style lang="scss">

  #fileselector .btn-default{
    color:#666 !important;
    padding: 8px;
    width:100%;
  }

  #fileselector .btn-default:hover{
    color:#666 !important;
  }
  .arquivo-info{
    width: 100%;
    font-style: italic;
    font-size: 10pt;
  }

  .download,.el-popover{
    width: auto !important;
  }
</style>


// WEBPACK FOOTER //
// download.vue?5cb152b0